// extracted by mini-css-extract-plugin
module.exports = {"dropdown":"style_dropdown__2UKh_","avatar":"style_avatar__myCA9"};